import type { ReactNode } from "react"

import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"

const COMING_SOON = ["Apothecary", "Assistant Coaches", "Cheerleaders"] as const

interface StaffExtrasCardProps {
  /** The reroll control row — draft's +/- Stepper, or manage's buy-only button. */
  children: ReactNode
}

export function StaffExtrasCard({ children }: StaffExtrasCardProps) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle>Staff &amp; Extras</CardTitle>
      </CardHeader>
      <CardContent className="space-y-3">
        <div>
          {children}
          <p className="mt-1 text-[11px] text-[var(--muted-foreground)]">
            Once per turn, retry a failed dice roll. Resets each half.
          </p>
        </div>
        {COMING_SOON.map((label) => (
          <div
            key={label}
            className="flex items-center justify-between gap-2 opacity-40"
          >
            <div>
              <p className="text-sm font-medium">{label}</p>
              <p className="text-xs text-[var(--accent-dim)] italic">
                Coming soon
              </p>
            </div>
          </div>
        ))}
      </CardContent>
    </Card>
  )
}
